import { Text, Flex } from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import { FormikProps } from 'formik';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

type PrincipalBalanceDailyAverageConfigProps = {
  formProps: FormikProps<CreditAgreement.Config.CommonPostgresQuery.Query.PrincipalBalanceDailyAverageQuery>;
};
export const PrincipalBalanceDailyAverageConfig = ({
  formProps,
}: PrincipalBalanceDailyAverageConfigProps) => {
  return (
    <Flex flexDir="column">
      <Flex mb="3">
        <Text>Starting Date Formula:</Text>
        <Editor
          value={formProps.values.parameterConfig.startDateFormula.formula}
          onChange={(val) =>
            formProps.setFieldValue(
              'parameterConfig.startDateFormula.formula',
              val,
            )
          }
          width="100%"
          theme="vs-dark"
          height="15vh"
        />
      </Flex>
      <Flex mb="3">
        <Text>Ending Date Formula:</Text>
        <Editor
          value={formProps.values.parameterConfig.endDateFormula.formula}
          onChange={(val) =>
            formProps.setFieldValue(
              'parameterConfig.endDateFormula.formula',
              val,
            )
          }
          width="100%"
          theme="vs-dark"
          height="15vh"
        />
      </Flex>
      <Flex mb="3" flexDir="column">
        <Text>Capital Provider Slugs</Text>
        {formProps.values.parameterConfig.capitalProviderSlugs.slugs.map(
          (cpSlug, idx) => {
            return (
              <Text
                ml="3"
                // eslint-disable-next-line react/no-array-index-key
                key={`portfolio-covenant-postgres-parameter-capital-provider-slug-${idx}`}
              >
                {cpSlug}
              </Text>
            );
          },
        )}
      </Flex>
    </Flex>
  );
};
